import PropTypes from "prop-types";
import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ title, description, keywords, image }) => {
    const siteTitle = "Muhammad Sajid";
    const defaultDescription =
        "Professional Portfolio of Muhammad Sajid - Frontend Developer & Cyber Security Enthusiast.";
    const defaultKeywords =
        "Muhammad Sajid, Frontend Developer, Cyber Security, Portfolio, React";
    const defaultImage = `${process.env.PUBLIC_URL}/images/org img.png`;

    const seoTitle = title
        ? title.includes(siteTitle)
            ? title
            : `${title} | ${siteTitle}`
        : siteTitle;
    const seoDescription = description || defaultDescription;
    const seoKeywords = keywords || defaultKeywords;
    const seoImage = image
        ? image.startsWith("http")
            ? image
            : `${process.env.PUBLIC_URL}${image.replace("./", "/")}`
        : defaultImage;

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Person",
        name: "Muhammad Sajid",
        url: "https://sajid.ami.bd/",
        image: seoImage,
        jobTitle: "Frontend Developer",
        description: defaultDescription,
        sameAs: ["https://github.com/Rexiop"],
    };

    return (
        <Helmet>
            <meta charSet="utf-8" />
            <title>{seoTitle}</title>
            <meta name="description" content={seoDescription} />
            <meta name="keywords" content={seoKeywords} />
            <meta name="author" content="Muhammad Sajid" />
            <meta name="robots" content="index, follow" />
            <meta
                name="viewport"
                content="width=device-width, initial-scale=1, shrink-to-fit=no"
            />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:title" content={seoTitle} />
            <meta property="og:description" content={seoDescription} />
            <meta property="og:image" content={seoImage} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:title" content={seoTitle} />
            <meta property="twitter:description" content={seoDescription} />
            <meta property="twitter:image" content={seoImage} />

            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(schemaData)}
            </script>
        </Helmet>
    );
};

SEO.propTypes = {
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string,
    image: PropTypes.string,
};

export default SEO;
